<div  id="navbarMobileButton">
    <i *ngIf="sidebarCollapsed" (click)="sidebarCollapsed = !sidebarCollapsed; showTranslateButton = false" class="fas fa-bars"  
    [ngClass]="{
      'landingMobile':isLandingPage,
      'bodyMobile':!isLandingPage}"></i>
</div>
<nav id="navbar" class="navbar navbar-expand-lg navbar-light" (click)="showTranslateButton = false">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
  <div class="collapse navbar-collapse navbarLogoWine" id="navbarSupportedContent">
    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a routerLink="/home" routerLinkActive="navLinkActive" class="nav-link hvr-underline-from-center" href="#">{{ 'navbar.hostel' | translate }}</a>
      </li>
      <li class="nav-item">
        <a routerLink="/rooms" routerLinkActive="navLinkActive" class="nav-link hvr-underline-from-center" href="#">{{ 'navbar.rooms' | translate }}</a>
      </li>
      <li id="navbarLogo" >
         <a routerLink="/landing" href="#">
          <img id="navbarLogoWine" src="assets/images/logosHabana/logo_habana_bordo.png" alt="" width="110px">
          <img id="navbarLogoWhite" src="assets/images/logosHabana/logo_habana_blanco.png" alt="" width="110px">
         </a> 
      </li>
      <li class="nav-item">
        <a routerLink="/location" routerLinkActive="navLinkActive" class="nav-link hvr-underline-from-center" href="#">{{ 'navbar.location' | translate }}</a>
      </li>
      <li class="nav-item">
        <a routerLink="/contact" routerLinkActive="navLinkActive" class="nav-link hvr-underline-from-center" href="#">{{ 'navbar.contact' | translate }}</a>
      </li>
    </ul>
  </div>

</nav>

<div id="translateLang">
    <div id="translateButtonWine">
      <button (click)="showTranslateButton = !showTranslateButton" class="buttonPrimary text-white">EN/ES</button>
    </div>
    <div [ngClass]="{'showTranslateButtonClass': showTranslateButton }" id="translateButtonGray">
      <p (click)="switchLanguage('en')" class="" [ngClass]="{'langSelected':langSelected == 'en'}">ENGLISH</p>
      <p (click)="switchLanguage('es')" class="" [ngClass]="{'langSelected': langSelected == 'es'}">ESPAÑOL</p>
    </div>
  </div>

<div id="navbarBorder"></div>

<div *ngIf="!sidebarCollapsed" id="overlay" (click)="sidebarCollapsed = !sidebarCollapsed"></div>

<div id="navbarMobile"   [ngStyle]="{'left': sidebarCollapsed ? '-260px' : '0px' }">
    <i class="fas fa-bars" (click)="sidebarCollapsed = !sidebarCollapsed"></i>
  <div>
    <ul>
      <li class="nav-item">
        <a name="homeContainer"  class="nav-link hvr-underline-from-center" (click)="scrollToSection($event)">{{ 'navbar.hostel' | translate }}</a>
      </li>
      <li class="nav-item">
        <a  name="roomsContainer"  class="nav-link hvr-underline-from-center" (click)="scrollToSection($event)">{{ 'navbar.rooms' | translate }}</a>
      </li>
      <li class="nav-item">
        <a name="locationContainer" class="nav-link hvr-underline-from-center" (click)="scrollToSection($event)">{{ 'navbar.location' | translate }}</a>
      </li>
      <li class="nav-item">
        <a name="contactContainer"  class="nav-link hvr-underline-from-center" (click)="scrollToSection($event)">{{ 'navbar.contact' | translate }}</a>
      </li>
 
    </ul>

    <div class="titleNavbarMobile">
        <h4 class="text-white">{{ 'landingPage.title' | translate }}</h4>
        <div class="separator"></div>
    </div>
  
</div>